/* unplugin-vue-components disabled */import { ElForm as __unplugin_components_5 } from 'element-plus/es';import 'element-plus/es/components/form/style/css';
import { ElButton as __unplugin_components_4 } from 'element-plus/es';import 'element-plus/es/components/button/style/css';
import { ElInput as __unplugin_components_3 } from 'element-plus/es';import 'element-plus/es/components/input/style/css';
import { ElFormItem as __unplugin_components_2 } from 'element-plus/es';import 'element-plus/es/components/form-item/style/css';
import { ElSelect as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/select/style/css';
import { ElOption as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/option/style/css';
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue";
import DateRangePicker from '@ultra/share/components/DateRangePicker/index.vue';
import CTable from '@ultra/share/components/CTable/index.vue';
import { apiUsdkSwitchConfOfficialProjectList } from '@/api/usdk';
import { useAppStore } from '@/store/modules/app';
import { apiInternalRefundOrderList } from '@/api/customerInternal';
import { UseGlobalConfig } from '@/utils/hooks';
import { useTaskStore } from '@/store/modules/downTask';
import dayjs from 'dayjs';
export default /*#__PURE__*/_defineComponent({
  __name: 'internalRefundOrder',
  setup(__props) {
    const {
      $channel
    } = UseGlobalConfig();
    const gameInfo = computed(() => useAppStore().gameInfo);
    const projectList = ref([]);
    const filter = ref({
      gid: 0,
      projectId: '',
      loginName: '',
      cmgeOrderNum: '',
      thirdOrderNum: '',
      refundStatus: 3
    });
    const orderDate = ref({
      startDate: dayjs().subtract(7, 'days').format('YYYY-MM-DD'),
      endDate: dayjs().format('YYYY-MM-DD')
    });
    const columns = [{
      label: 'ID',
      prop: 'id',
      isForce: true,
      isDefault: true
    }, {
      label: '登录名',
      prop: 'loginName',
      isDefault: true
    }, {
      label: '项目ID',
      prop: 'projectId'
    }, {
      label: '产品名称',
      prop: 'name'
    }, {
      label: '平台订单号',
      prop: 'cmgeOrderNum',
      isDefault: true
    }, {
      label: '设备号',
      prop: 'deviceNum',
      isDefault: true
    }, {
      label: '档位',
      prop: 'channelGoodsId',
      isDefault: true
    }, {
      label: '退款金额',
      prop: 'amount',
      isDefault: true
    }, {
      label: '道具名称',
      prop: 'propName',
      isDefault: true
    }, {
      label: '退款时间',
      prop: 'refundTime',
      isDefault: true
    }, {
      label: '退款状态',
      prop: 'refundStatus',
      isDefault: true
    }];
    const tableData = ref([]);
    const tableLoading = ref(false);
    const getTableData = () => {
      tableLoading.value = true;
      let {
        startDate,
        endDate
      } = orderDate.value;
      apiInternalRefundOrderList({
        startDate,
        endDate,
        cids: $channel === null || $channel === void 0 ? void 0 : $channel.OFFICIAL_IOS_CHANNEL_ID,
        ...filter.value
      }).then(res => {
        if (res.code === 0) {
          tableData.value = res.data;
        }
      }).catch(() => {
        tableData.value = [];
      }).finally(() => {
        tableLoading.value = false;
      });
    };
    const getProjectList = gid => {
      apiUsdkSwitchConfOfficialProjectList({
        gid
      }).then(res => {
        if (res.code === 0) {
          projectList.value = res.data;
        }
      });
    };
    watch(() => gameInfo.value, val => {
      if (val && val.Id) {
        filter.value.gid = val.Id;
        getProjectList(val.Id);
      }
    }, {
      immediate: true,
      deep: true
    });
    const {
      setTask
    } = useTaskStore();
    const exportTable = () => {
      let [startTime, endTime] = [orderDate.value.startDate, orderDate.value.endDate];
      setTask({
        api: apiInternalRefundOrderList,
        page: 'pageNumber',
        pageSize: 'pageSize',
        params: {
          startTime,
          endTime,
          cids: $channel === null || $channel === void 0 ? void 0 : $channel.OFFICIAL_IOS_CHANNEL_ID,
          ...filter.value
        },
        data: 'data',
        total: 'total',
        excel: {
          title: `国内退款订单`,
          header: ['ID', '登录名', '平台订单号', '设备号', '档位', '退款金额', '道具名称', '退款时间', '退款状态'],
          field: ['id', 'loginName', 'cmgeOrderNum', 'deviceNum', 'channelGoodsId', 'amount', 'propName', 'refundTime', 'refundStatus']
        }
      });
    };
    onMounted(() => {
      getTableData();
    });
    return (_ctx, _cache) => {
      const _component_el_option = __unplugin_components_0;
      const _component_el_select = __unplugin_components_1;
      const _component_el_form_item = __unplugin_components_2;
      const _component_el_input = __unplugin_components_3;
      const _component_el_button = __unplugin_components_4;
      const _component_el_form = __unplugin_components_5;
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_el_form, {
        inline: "",
        class: "marginT20"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "项目"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_select, {
            filterable: "",
            clearable: "",
            modelValue: _unref(filter).projectId,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(filter).projectId = $event),
            allowClear: "",
            placeholder: "请选择项目"
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(projectList), (item, index) => {
              return _openBlock(), _createBlock(_component_el_option, {
                value: item.projectId,
                key: index,
                label: item.projectName
              }, null, 8, ["value", "label"]);
            }), 128))]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "登录名"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: _unref(filter).loginName,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _unref(filter).loginName = $event),
            placeholder: "输入登录名"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "退款状态"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_select, {
            modelValue: _unref(filter).refundStatus,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _unref(filter).refundStatus = $event),
            placeholder: "选择退款状态"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_option, {
              value: 3,
              label: "全部"
            }), _createVNode(_component_el_option, {
              value: 0,
              label: "未匹配订单"
            }), _createVNode(_component_el_option, {
              value: 1,
              label: "未通知"
            }), _createVNode(_component_el_option, {
              value: 2,
              label: "已通知"
            }), _createVNode(_component_el_option, {
              value: -1,
              label: "通知CP失败"
            })]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "下单时间"
        }, {
          default: _withCtx(() => [_createVNode(DateRangePicker, {
            startValue: _unref(orderDate).startDate,
            "onUpdate:startValue": _cache[3] || (_cache[3] = $event => _unref(orderDate).startDate = $event),
            endValue: _unref(orderDate).endDate,
            "onUpdate:endValue": _cache[4] || (_cache[4] = $event => _unref(orderDate).endDate = $event),
            valueFormat: "YYYY-MM-DD",
            type: "daterange"
          }, null, 8, ["startValue", "endValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "平台订单号"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: _unref(filter).cmgeOrderNum,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => _unref(filter).cmgeOrderNum = $event),
            placeholder: "输入平台订单号"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "第三方订单号"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: _unref(filter).thirdOrderNum,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => _unref(filter).thirdOrderNum = $event),
            placeholder: "输入第三方订单号"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            onClick: getTableData,
            type: "primary"
          }, {
            default: _withCtx(() => [_createTextVNode("搜索")]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }), _createVNode(CTable, {
        tableColumns: columns,
        tableData: _unref(tableData),
        loading: _unref(tableLoading)
      }, {
        top: _withCtx(() => [_createVNode(_component_el_button, {
          class: "marginL10",
          onClick: exportTable,
          type: "primary"
        }, {
          default: _withCtx(() => [_createTextVNode("导出数据")]),
          _: 1
        })]),
        _: 1
      }, 8, ["tableData", "loading"])], 64);
    };
  }
});